const swiperComparison = new Swiper('.comparison-slider__contents', {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 12,
  pagination: {
    el: '.comparison-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: `.swiper-button-next-comparison`,
    prevEl: `.swiper-button-prev-comparison`,
    enabled: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 3,
    }
  }
});
